import { axios } from "../../../lib/axios";

export const deleteSingleCard = async (cardId: any) => {
  try {
    const response = await axios.delete(`/cards/${cardId}`);

    return response;
  } catch (error) {
    // Handle error here
    throw new Error("Error deactivating category: " + error);
  }
};
